import React from "react";
import "../../styles/Header.css";
import classNames from "classnames";

export interface HeaderNavProps {
  breadcrumb?: React.ReactNode;
  activeItem?: number;
  children?: React.ReactChildren;
  title?: string;
}

function createTabs(tabs: React.ReactChildren, activeItem: number): React.ReactNode[] {
  return React.Children.map<React.ReactNode, React.ReactNode>( tabs, (tab, index) => {
    const classes = classNames("Item header-nav-link header-nav-tab", {
      "header-nav-link--active": activeItem === index
    });

    return (
      <div key={index} className={classes}>
        {tab}
      </div>
    )
  })
}

function createHeaderTitle(title: string) {
  return (<div className={'Item header-nav-title'}>{title}</div>)
}

const HeaderNav = (props: HeaderNavProps) => {
  return (
    <div className={"HeaderNav header-layout--right"}>
      <div className={"Item item--left header-nav-link"}>{props.breadcrumb}</div>
      {props.title !== undefined ? createHeaderTitle(props.title) : ""}
      {props.children && props.activeItem !== undefined ? createTabs(props.children, props.activeItem) : ""}
    </div>
  )
};

export default HeaderNav;
